import { useEffect, useState } from 'react';
import { useAuthStore } from '../store';
import { api, CscaSubjectCatalogItem } from '../utils/api';

export default function CscaSubjectPicker({ level, onChange }: { level: number; onChange: (level: number) => void }) {
  const token = useAuthStore(state => state.token);
  const [subjects, setSubjects] = useState<CscaSubjectCatalogItem[]>([]);
  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    api.getCscaCatalog(token).then(result => {
      if (cancelled) return;
      setSubjects((result.subjects || []).filter(subject => subject.available));
    }).catch(() => { if (!cancelled) setSubjects([]); });
    return () => { cancelled = true; };
  }, [token]);
  useEffect(() => {
    if (subjects.length && !subjects.some(subject => subject.level === level)) onChange(subjects[0].level);
  }, [subjects, level, onChange]);
  return <div className="flex flex-wrap gap-2" aria-label="选择 CSCA 科目">
    {subjects.map(subject => <button key={subject.level} type="button" aria-pressed={subject.level === level}
      onClick={() => onChange(subject.level)} className={`flex flex-col items-start rounded-xl border px-4 py-2.5 text-sm font-bold ${subject.level === level ? 'border-indigo-600 bg-indigo-600 text-white' : 'border-indigo-100 bg-white text-indigo-900 hover:bg-indigo-50'}`}>
      <span>{subject.name}</span>
      <span className={`mt-0.5 text-[10px] font-semibold ${subject.level === level ? 'text-indigo-100' : 'text-slate-500'}`}>level {subject.level}</span>
    </button>)}
  </div>;
}
